import { render, staticRenderFns } from "./BranchPayments.vue?vue&type=template&id=62d8ffd5"
import script from "./BranchPayments.vue?vue&type=script&lang=js"
export * from "./BranchPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports